import { mapActions, mapGetters, mapState } from 'vuex';
import { MODALS } from '@/components/app/app-modals/modals-constants';
import { waitForStatusReady } from '@/utils/mutex';

const STATUS_PENDING = 2;

const accountVerifyMixin = {
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapGetters('user', ['isLoggedIn']),
    ...mapState('user', ['userData', 'status']),
    ...mapState('wallet', ['balance']),
    accountLink() {
      if (this.isLayoutMobile) return '/account';
      if (this.isWalletEnabled) return '/account/wallet';
      return '/account/details';
    },
    hasUserClassicEnabled() {
      return !this.isLoggedIn || (this.isLoggedIn && this.status.isClassicEnabled !== false);
    },
    isUserVerified() {
      const idVerified = this.userData.idVerified;
      const verificationStatus = this.userData.verificationStatus;
      if (!this.isLoggedIn) return true;
      return typeof idVerified !== 'undefined'
        ? idVerified || verificationStatus === STATUS_PENDING
        : false;
    },
    isUserVerifiedFully() {
      const idVerified = this.userData.idVerified;
      const verificationStatus = this.userData.verificationStatus;
      if (!this.isLoggedIn) return true;
      return typeof idVerified !== 'undefined'
        ? idVerified && verificationStatus !== STATUS_PENDING
        : false;
    },
    isWalletEnabled() {
      const idVerified = this.userData.idVerified;
      if (!this.isLoggedIn) return true;
      return typeof idVerified !== 'undefined' ? idVerified : false;
    },
    isUserBalanceEmpty() {
      return this.balance && this.balance.accountBalanceDecimal === 0;
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup', 'setCurrentPopupOptions']),
    checkDataIfUserIsVerified(data) {
      if (!this.isLoggedIn) return true;
      return data && (data.idVerified === true || data.verificationStatus === STATUS_PENDING);
    },
    showAccountVerifyPopup(options = null) {
      if (!this.isLoggedIn) return;
      waitForStatusReady().then(() => {
        if (this.isUserVerified) {
          return;
        }
        this.setCurrentPopup(MODALS.ACCOUNT_VERIFY);
        if (options !== null) {
          this.setCurrentPopupOptions(options);
        }
      });
    },
    showAddFundsPopup() {
      this.setCurrentPopup(MODALS.ADD_FUNDS);
    },
  },
};

export default accountVerifyMixin;
